import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import "../styles/calendar.css";
import { Card } from "./ui/card";
import s from "../styles/modules/Calendar.module.scss";
import { useCalendar } from "../hooks/useCalendar";

const CalendarComponent = () => {
  const { value, onChange, dateArr } = useCalendar();
  return (
    <Card className={`${s.calendar} mx-auto flex min-w-[350px] items-center shadow-sm md:ml-0`}>
      <Calendar
        onChange={(value: Date) => onChange(value)}
        value={value}
        tileClassName={({ date }) => {
          if (dateArr && dateArr.find((x) => x === moment(date).format("YYYY-MM-DD"))) {
            return "highlight";
          }
        }}
      />
    </Card>
  );
};
export default CalendarComponent;
